import { Box, Tab, Tabs, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import BackButton from '../components/BackButton';
import AssignmentAnswers from '../components/assignments/AssignmentAnswers';
import Assignments from '../components/assignments/Assignments';

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function AssignmentPage() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <BackButton link={-1} />
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Answers" {...a11yProps(0)} />
                    <Tab label="Assignments" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <AssignmentAnswers />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <Assignments />
            </CustomTabPanel>
        </Box>
    )
}

export default AssignmentPage